import { useState, useEffect } from 'react';
import get from 'lodash/get';
import has from 'lodash/has';

import { ajaxExceptionMessage } from '@skunexus/utils';

import * as API from './api';

const INIT_FORM_DATA_STATE = {
    warehouses: [],
    websites: [],
    msiSources: [],
};

export const useMagento2FormPart = ({ details, formData, errorNotification }) => {
    const [useMsi, setUseMsi] = useState(get(formData, 'settings.inventory_uses_msi', false));
    const [dictionaries, setDictionaries] = useState(INIT_FORM_DATA_STATE);
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        let mounted = true;

        const getDictionaries = async () => {
            setLoading(true);
            try {
                const result = await API.fetchDictionaries({
                    integrationId: get(details, 'id'),
                });

                const data = get(result, `data.data`);
                if (!data) {
                    throw new Error(`Couldn't load Dictionaries`);
                }
                if (mounted) {
                    setLoading(false);
                    setDictionaries((state) => ({
                        ...state,
                        warehouses: get(data, 'warehouse.grid.rows', []),
                        websites: get(data, 'integration.magento2.websites', []),
                        msiSources: get(data, 'integration.magento2.msiSources', []),
                    }));
                }
            } catch (e) {
                errorNotification(ajaxExceptionMessage(e));
                if (mounted) {
                    setLoading(false);
                }
            }
        };

        if (has(details, 'id')) {
            getDictionaries();
        }

        return () => {
            mounted = false;
        };
    }, [details.id]);

    return {
        dictionaries,
        isLoading,
        useMsi,
        setUseMsi,
    };
};
